<template>
  <div id="contenedor-editar-catalogo-auditoria-etiqueta">
    <v-form ref="editarCatalogoAuditoriaEtiqueta" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar etiqueta de auditoria
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <custom-text-field
              cols="8"
              label="Descripción"
              v-model="catalogoAuditoriaEtiqueta.descripcion"
              :rules="[mixReglas.requerido]"
              required
            >
            </custom-text-field>

            <v-label>Color</v-label>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-2"
                  :color="catalogoAuditoriaEtiqueta.color"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
              </template>
              <v-color-picker
                v-model="catalogoAuditoriaEtiqueta.color"
                mode="hexa"
                hide-canvas
                hide-inputs
                hide-mode-switch
                hide-sliders
                show-swatches
                swatches-max-height="200"
              >
              </v-color-picker>
            </v-menu>
            <v-switch v-model="catalogoAuditoriaEtiqueta.esTextoClaro" label="¿Texto Blanco?" inset>
            </v-switch>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarCatalogoAuditoriaEtiqueta"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoAuditoriasEtiquetas from './mixCatalogoAuditoriasEtiquetas';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoAuditoriasEtiquetasEditar',
  mixins: [mixCatalogoAuditoriasEtiquetas],
  props: {
    catalogoAuditoriaEtiquetaEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      catalogoAuditoriaEtiqueta: {
        descripcion: this.catalogoAuditoriaEtiquetaEditar.descripcion,
        color: this.catalogoAuditoriaEtiquetaEditar.color,
        esTextoClaro: this.catalogoAuditoriaEtiquetaEditar.esTextoClaro,
      },
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarCatalogoAuditoriaEtiqueta.reset();
    },
  },
};
</script>

<style></style>
